import { h, Fragment } from 'preact'
import { useEffect, useState } from 'preact/compat'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { config } from '../../../config'
import { dispatchPaymentDetailsIframeEvent } from '../../../helpers/events'
import { useTranslations } from '../../../hooks/useTranslations'
import { billingAddressUpdate } from '../../../redux/slice/billingAddressSlice'
import {
  cardsDelete,
  cardSelect,
  cardsUpdateAfterDeletion,
  clearSelection,
  setAddCard,
} from '../../../redux/slice/cardsSlice'
import {
  pageStateUpdate,
  componentsLoadUpdate,
} from '../../../redux/slice/pageStateSlice'
import { clearAuthoriseData } from '../../../redux/slice/paymentResponseSlice'
import { paymentUpdate } from '../../../redux/slice/paymentSlice'
import {
  balanceCheckError,
  clearBalanceData,
  updateBalanceData,
  updateBalancePending,
} from '../../../redux/slice/prePaymentSlice'
import { transactionDetailsUpdate } from '../../../redux/slice/transactionDetailsSlice'
import '../../../styles.scss'
import store from '../../../redux/store'
import Modal from '../../Common/Modal'

export default function PaymentDetailsPCIIframe({
  iframeRef,
  token,
  theme,
  stylesHref,
  paymentMethod,
}) {
  const [iframeHeight, setIframeHeight] = useState(777)
  const dispatch = useDispatch()
  const l10n = useTranslations()
  const [isManyCards, setIsManyCards] = useState(false)
  const [isDeletionModalOpened, setIsDeletionModalOpened] = useState(false)

  const onDeleteConfirm = () => {
    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFECardsDeletionConfirm',
      },
      iframeRef?.current?.contentWindow,
    )
    setIsDeletionModalOpened(false)
  }

  const onDeleteCancel = () => {
    setIsDeletionModalOpened(false)
  }

  const handlePCIDetailsMessage = e => {
    const type = e?.data?.type

    // to handle resize of content inside the iframe
    if (type === 'MFEWindowResize') {
      setIframeHeight(e.data.data.windowHeight)
    } else if (type === 'MFEGetStoreUpdate') {
      dispatchPaymentDetailsIframeEvent(
        {
          type: 'MFEStoreUpdate',
          data: store.getState(),
        },
        iframeRef?.current?.contentWindow,
      )

      dispatchPaymentDetailsIframeEvent(
        {
          type: 'PaymentsMFEChangeAttribute',
          data: {
            attributeName: 'token',
            value: token,
          },
        },
        iframeRef?.current?.contentWindow,
      )

      dispatchPaymentDetailsIframeEvent(
        {
          type: 'PaymentsMFEChangeAttribute',
          data: {
            attributeName: 'theme',
            value: theme,
          },
        },
        iframeRef?.current?.contentWindow,
      )

      dispatchPaymentDetailsIframeEvent(
        {
          type: 'PaymentsMFEChangeAttribute',
          data: {
            attributeName: 'styles-href',
            value: stylesHref,
          },
        },
        iframeRef?.current?.contentWindow,
      )

      dispatchPaymentDetailsIframeEvent(
        {
          type: 'PaymentsMFEMethodChange',
          data: paymentMethod,
        },
        iframeRef?.current?.contentWindow,
      )
    } else if (type === 'MFEShowDeletionModalShow') {
      setIsManyCards(e.data.data.isManyCards > 1)
      setIsDeletionModalOpened(true)
    } else if (type === 'MFEStoreDispatch') {
      if (e.data.data.actionType === 'transactionDetailsUpdate') {
        dispatch(
          transactionDetailsUpdate({
            ...e.data.data.message,
          }),
        )
      } else if (e.data.data.actionType === 'billingAddressUpdate') {
        dispatch(billingAddressUpdate(e.data.data.message))
      } else if (e.data.data.actionType === 'cardSelect') {
        dispatch(cardSelect(e.data.data.message))
      } else if (e.data.data.actionType === 'setAddCard') {
        dispatch(setAddCard(e.data.data.message))
      } else if (e.data.data.actionType === 'componentsLoadUpdate') {
        dispatch(componentsLoadUpdate(e.data.data.message))
      } else if (e.data.data.actionType === 'cardsUpdateAfterDeletion') {
        dispatch(cardsUpdateAfterDeletion(e.data.data.message))
      } else if (e.data.data.actionType === 'cardsDelete') {
        dispatch(cardsDelete(e.data.data.message))
      } else if (e.data.data.actionType === 'clearSelection') {
        dispatch(clearSelection())
      } else if (e.data.data.actionType === 'clearAuthoriseData') {
        dispatch(clearAuthoriseData())
      } else if (e.data.data.actionType === 'paymentUpdate') {
        dispatch(
          paymentUpdate({
            ...e.data.data.message,
          }),
        )
      } else if (e.data.data.actionType === 'PaymentsMFEIsCardNumberOmnio') {
        dispatch(
          pageStateUpdate({
            isCardNumberOmnio: e.data.data.message,
          }),
        )
      } else if (e.data.data.actionType === 'PaymentsMFEOmnioCheckPending') {
        dispatch(updateBalancePending(e.data.data.message))
      } else if (
        e.data.data.actionType === 'PaymentsMFEOmnioUpdateBalanceData'
      ) {
        dispatch(updateBalanceData(e.data.data.message))
      } else if (
        e.data.data.actionType === 'PaymentsMFEOmnioBalanceCheckError'
      ) {
        dispatch(balanceCheckError({ errorCode: e.data.data.errorCode }))
      } else if (
        e.data.data.actionType === 'PaymentsMFEOmnioClearBalanceData'
      ) {
        dispatch(clearBalanceData())
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handlePCIDetailsMessage)

    return () => window.removeEventListener('message', handlePCIDetailsMessage)
  }, [paymentMethod])

  useEffect(() => {
    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFEChangeAttribute',
        data: {
          attributeName: 'token',
          value: token,
          apiEndpoint: config.apiEndpoint,
        },
      },
      iframeRef?.current?.contentWindow,
    )
  }, [token])

  useEffect(() => {
    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFEChangeAttribute',
        data: {
          attributeName: 'theme',
          value: theme,
        },
      },
      iframeRef?.current?.contentWindow,
    )
  }, [theme])

  useEffect(() => {
    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFEChangeAttribute',
        data: {
          attributeName: 'styles-href',
          value: stylesHref,
        },
      },
      iframeRef?.current?.contentWindow,
    )
  }, [stylesHref])

  useEffect(() => {
    store.subscribe(() => {
      dispatchPaymentDetailsIframeEvent(
        {
          type: 'MFEStoreUpdate',
          data: store.getState(),
        },
        iframeRef?.current?.contentWindow,
      )
    })
  }, [])

  useEffect(() => {
    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFEMethodChange',
        data: paymentMethod,
      },
      iframeRef?.current?.contentWindow,
    )
  }, [paymentMethod])

  return (
    <>
      <iframe
        style={{
          width: 'calc(100% + 7px)',
          height: `calc(${iframeHeight} + 1px)`,
          marginLeft: '-3px',
          display: paymentMethod === 'Card' ? 'block' : 'none',
        }}
        ref={iframeRef}
        src={config.DETAILS_IFRAME_URL}
        data-testid="pci-iframe"
      />

      <Modal
        isOpened={isDeletionModalOpened}
        onConfirm={onDeleteConfirm}
        onCancel={onDeleteCancel}
        title={l10n.t(isManyCards ? 'Delete cards' : 'Delete card')}
        cancelButtonText={l10n.t(isManyCards ? 'Keep Cards' : 'Keep Card')}
        confirmButtonText={l10n.t('Delete')}
      >
        <>
          <div className="card-deletion-confirm-area">
            <h4 className="lead">
              {l10n.t(
                isManyCards
                  ? 'Are you sure you want to delete these cards?'
                  : 'Are you sure you want to delete this card?',
              )}
            </h4>
            <p>
              {l10n.t(
                isManyCards
                  ? 'To remove these cards from your ‘saved cards’ list, click ‘delete’'
                  : 'To remove this card from your ‘saved cards’ list, click ‘delete’',
              )}
            </p>
          </div>
        </>
      </Modal>
    </>
  )
}

PaymentDetailsPCIIframe.propTypes = {
  iframeRef: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  theme: PropTypes.string,
  stylesHref: PropTypes.string,
  paymentMethod: PropTypes.string,
}
